<template>
  <div :class="['d-flex gap-1 skin-problem-wrapper', { images: mode === 'images', numbers: mode === 'numbers' }]">
    <div :class="['skin-problem', { mobile: isMobile }]">
      {{ label }}
    </div>
    <div class="d-flex">
      <div
        v-for="level in levels.slice(0, levelsLength)"
        :key="level.key"
        @click="handleLevel(level.value)"
        :class="['d-flex flex-column align-center item-block', isMobile ? 'mobile' : '']"
      >
        <div :class="['item-border', { 'item-selected': level.value === value }]">
          <slot name="levels" v-bind="level">
            <div :class="['item', isMobile ? 'mobile' : '']">{{ level.value }}</div>
          </slot>
        </div>
        <slot name="label" v-bind="level"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { PropOptions } from 'vue'

export default {
  props: {
    /** @type {PropOptions<string?>} */
    label: {
      type: String,
      default: null,
    },
    /** @type {PropOptions<number?>} */
    value: {
      type: Number,
      default: null,
    },
    /** @type {PropOptions<boolean>} */
    mobile: {
      type: Boolean,
      default: false,
    },
    /** @type {PropOptions<'images' | 'numbers'>} */
    mode: {
      type: String,
      required: true,
    },
    levelsLength: {
      type: Number,
      default: 5,
    },
  },

  data() {
    return {
      currentLevel: null,
      levels: [
        { value: 0, key: 'ausente', label: 'Ausente' },
        { value: 1, key: 'leve', label: 'Leve' },
        { value: 2, key: 'moderado', label: 'Moderado' },
        { value: 3, key: 'grave', label: 'Grave' },
        { value: 4, key: 'muito-grave', label: 'Muito grave' },
      ],
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown || this.mobile
    },
  },
  methods: {
    handleLevel(inputValue) {
      this.$emit('input', inputValue)
    },
  },
}
</script>

<style scoped>
.skin-problem-wrapper.images {
  flex-direction: column;
}
.skin-problem-wrapper.numbers {
  flex-direction: row;
  align-items: center;
}

.skin-problem {
  font-size: 16px;
  letter-spacing: 0.5px;
  color: var(--v-neutral-lighten17);
  font-weight: 400;
  width: 100px;
  margin-right: 16px;
}

.skin-problem.mobile {
  margin-bottom: 8px;
  margin-right: 0;
}

.item {
  border-radius: 8px;
  background-color: #e0f0ff;
  width: 64px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 14px;
  color: var(--v-neutral-lighten17);
  cursor: pointer;
}

.item:hover {
  border: 2px solid #006cd0;
}
.item.mobile:hover {
  border: none;
}

.item-border {
  border: 2px solid transparent;
}

.item-block + .item-block {
  margin-left: 6px;
}
.item-block.mobile + .item-block.mobile {
  margin-left: 2px;
}
.item-selected {
  position: relative;
}
.item-selected::after {
  box-shadow: inset 0px 0px 0px 2px #006cd0;
  border-radius: 8px;
  content: '';
  display: block;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
